import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-product-items-slider',
    templateUrl: './product-items-slider.component.html',
    styleUrls: ['./product-items-slider.component.css'],
    standalone: false
})
export class ProductItemsSliderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
